// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";

import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import store from "./store";
import cnzzAnalytics from 'vue-cnzz-analytics'

// 引入打印插件
import Print from "vue-print-nb";
Vue.use(Print);

// 引入全局公共方法
import commonFunc from "./utils/commonFunc";
Vue.use(commonFunc);

import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/base.css";
import "@/assets/css/common.css";
import "@/assets/css/index.css";

Vue.use(ElementUI);
// 启动插件
Vue.use(cnzzAnalytics, {
  router: router,
  siteIdList: [
    1281041696,
    1281041696
  ],
  isDebug: false
});

Vue.use(require("vue-wechat-title"));

Vue.config.productionTip = false;

// 引入 自定义组件 并 设为全局组件
import Component from "./components";
Vue.use(Component);

// 引入 静态变量 并挂载到Vue实例
import config from "./config";
Vue.prototype.config = config;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store, //store:store 和router一样，将我们创建的Vuex实例挂载到这个vue实例中
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js